import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import Validator from 'validatorjs';

import {
  Form,
  Button,
  Modal,
  Message,
  Icon,
  Input,
  TextArea,
  Select,
} from 'semantic-ui-react';

class MarketIndexForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      notes: '',
      value: '',
      surchargeStatus: '',
      surchargeAmount: '',
      displaySurcharge: '',
      displaySurchargeAmount: false,
      updated: true,
      errors: {},
    };
  }

  componentDidMount() {
    const { marketIndex } = this.props;
    if (!isEmpty(marketIndex)) {
      const {
        id,
        notes,
        value,
        surchargeStatus,
        surchargeAmount,
        displaySurcharge,
        displaySurchargeAmount,
      } = marketIndex;
      this.setState({
        id: parseInt(id, 10),
        notes,
        value,
        surchargeStatus,
        surchargeAmount,
        displaySurcharge,
        displaySurchargeAmount,
        updated: true,
      });
    }
  }

  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
    } = this.props;

    const {
      id,
      notes,
      value,
      surchargeStatus,
      surchargeAmount,
      displaySurcharge,
      displaySurchargeAmount,
      errors,
    } = this.state;

    const onChangeHandler = field => event => {
      errors.surchargeAmount = '';
      const { displaySurchargeAmount: currentDisplaySurchargeAmount } = this.state;
      if (field === 'surchargeAmount') {
        const invalidOn = currentDisplaySurchargeAmount
          && (event.target.value <= 0 || isEmpty(event.target.value));
        const invalidOff = !currentDisplaySurchargeAmount
          && (event.target.value !== 0 || isEmpty(event.target.value));
        if (invalidOn) {
          errors.surchargeAmount = 'Surcharge amount must be greater than 0 to turn this on';
          this.setState({ [field]: event.target.value, updated: false });
        }
        if (invalidOff) {
          errors.surchargeAmount = 'Surcharge amount must be 0 to turn this off';
          this.setState({ [field]: event.target.value, updated: false });
        }
        if (!invalidOn && !invalidOff) {
          if (currentDisplaySurchargeAmount) {
            if (event.target.value > 0 && event.target.value <= 500) {
              this.setState({ [field]: event.target.value, updated: true });
            } else {
              errors.surchargeAmount = 'Please enter a positive amount between 1 - 500';
              this.setState({ [field]: event.target.value, updated: false });
            }
          } else if (!currentDisplaySurchargeAmount) {
            if (event.target.value > 0) {
              errors.surchargeAmount = 'Surcharge amount must be 0 to turn this off';
              this.setState({ [field]: event.target.value, updated: false });
            } else {
              this.setState({ [field]: event.target.value, updated: true });
            }
          }
        }
      } else {
        this.setState({ [field]: event.target.value, updated: true });
      }
    };

    const onSelectHandler = field => (event, data) => {
      const { surchargeAmount: currentSurchargeAmount } = this.state;
      errors.surchargeAmount = '';
      const invalidOn = data.value && (currentSurchargeAmount <= 0 || isEmpty(currentSurchargeAmount));
      const invalidOff = !data.value && (currentSurchargeAmount !== 0 || isEmpty(currentSurchargeAmount));
      if (invalidOn) {
        errors.surchargeAmount = 'Surcharge amount must be  greater than 0 to turn this on';
        this.setState({ [field]: data.value, updated: false });
      }
      if (invalidOff) {
        errors.surchargeAmount = 'Surcharge amount must be 0 to turn this off';
        this.setState({ [field]: data.value, updated: false });
      }
      if (!invalidOn && !invalidOff) {
        this.setState({ [field]: data.value, updated: true });
      }
    };

    const validationRules = {
      notes: 'required',
      value: 'required|numeric|customValidateMarketIndexPrice',
      surchargeAmount: 'numeric|customValidateSurcharge',
    };

    Validator.register(
      'customValidateMarketIndexPrice',
      val => {
        if (val >= 0 && val <= 200) {
          return val >= 0;
        }
        return false;
      },
      'Please enter a positive number between 0 - 200'
    );

    Validator.register(
      'customValidateSurcharge',
      function customValidateSurcharge(val) {
        const { displaySurchargeAmount: dsa } = this.validator.input;
        if (dsa) {
          if (val >= 0 && val <= 500) {
            return true;
          }
          return false;
        }
        return true;
      },
      'Please enter a positive amount between 1 - 500'
    );

    const displaySurchargeOptions = [
      { key: 1, text: 'Yes', value: true },
      { key: 2, text: 'No', value: false },
    ];
    const displaySurchargeAmountOptions = [
      { key: 1, text: 'Yes', value: true },
      { key: 2, text: 'No', value: false },
    ];

    const submitForm = () => {
      const { updated } = this.state;
      if (updated === false) {
        return false;
      }
      const validation = new Validator(this.state, validationRules);
      if (validation.fails()) {
        this.setState({ errors: validation.errors.all() });
        return false;
      }
      onSubmitHandler({
        id: parseInt(id, 10),
        notes,
        value,
        surchargeStatus,
        surchargeAmount: parseFloat(surchargeAmount),
        displaySurcharge,
        displaySurchargeAmount,
      });
      this.setState({ errors: {} });
      return true;
    };

    return (
      <Modal
        open={isModalOpen}
        closeIcon
        onClose={onCloseHandler}
        closeOnEscape={false}
        closeOnRootNodeClick={false}
      >
        <Modal.Header>{id && 'Edit Market Index'}</Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            {error && (
              <Message negative>
                <p>{error}</p>
              </Message>
            )}
            <Form>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.value)}>
                  <label htmlFor='value'>Value</label>
                  <Input
                    id='value'
                    name='value'
                    value={value}
                    onChange={onChangeHandler('value')}
                  />
                  {errors.value && <span>{errors.value}</span>}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.notes)}>
                  <label htmlFor='notes'>Notes</label>
                  <TextArea
                    id='notes'
                    name='notes'
                    value={notes}
                    onChange={onChangeHandler('notes')}
                  />
                  {errors.notes && <span>{errors.notes}</span>}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field required error={!isEmpty(errors.surchargeStatus)}>
                  <label htmlFor='surchargeStatus'>Surcharge Status</label>
                  <Input
                    id='surchargeStatus'
                    name='surchargeStatus'
                    value={surchargeStatus}
                    onChange={onChangeHandler('surchargeStatus')}
                  />
                  {errors.surchargeStatus && (
                    <span>{errors.surchargeStatus}</span>
                  )}
                </Form.Field>
                <Form.Field required error={!isEmpty(errors.surchargeAmount)}>
                  <label htmlFor='surchargeAmount'>Surcharge Amount</label>
                  <Input
                    id='surchargeAmount'
                    name='surchargeAmount'
                    value={surchargeAmount}
                    onChange={onChangeHandler('surchargeAmount')}
                  />
                  {errors.surchargeAmount && (
                    <span>{errors.surchargeAmount}</span>
                  )}
                </Form.Field>
              </Form.Group>
              <Form.Group widths='equal'>
                <Form.Field>
                  <label htmlFor='displaySurcharge'>Display on DS.com ACO Acknowlegdement Page</label>
                  <Select
                    id='displaySurcharge'
                    options={displaySurchargeOptions}
                    name='displaySurcharge'
                    onChange={onSelectHandler('displaySurcharge')}
                    value={displaySurcharge}
                  />
                </Form.Field>
                <Form.Field
                  required
                  error={!isEmpty(errors.displaySurchargeAmount)}
                >
                  <label htmlFor='displaySurchargeAmount'>Display Surcharge Amount on Market Condition</label>
                  <Select
                    id='displaySurchargeAmount'
                    options={displaySurchargeAmountOptions}
                    name='displaySurchargeAmount'
                    onChange={onSelectHandler('displaySurchargeAmount')}
                    value={displaySurchargeAmount}
                  />
                  {errors.displaySurchargeAmount && (
                    <span>{errors.displaySurchargeAmount}</span>
                  )}
                </Form.Field>
              </Form.Group>
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {submitting && (
            <Button loading positive>
              Submitting...
            </Button>
          )}

          {!submitting && (
            <Button color='green' onClick={submitForm} inverted>
              <Icon name='checkmark' /> Update
            </Button>
          )}
          <Button onClick={onCloseHandler}>Cancel</Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

MarketIndexForm.propTypes = {
  marketIndex: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    notes: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    surchargeStatus: PropTypes.string,
    surchargeAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    displaySurcharge: PropTypes.bool,
    displaySurchargeAmount: PropTypes.bool,
  }),
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
};

MarketIndexForm.defaultProps = {
  marketIndex: {},
  isModalOpen: false,
  onCloseHandler: () => {},
  onSubmitHandler: () => {},
  error: '',
  submitting: false,
};

export default MarketIndexForm;
